import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/costs-structures",
		component: lazy(() => import("./AdminCostsPage")),
	},
]);